import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
	user: any;
	loading: boolean;
}

const initialState: AuthState = {
	user: {},
	loading: false,
};

export const authenticationSlice = createSlice({
	name: "authentication",
	initialState,
	reducers: {
		setUser: (state, action: PayloadAction<any>) => {
			state.user = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
	},
});

export const { setUser, setLoading } = authenticationSlice.actions;

export default authenticationSlice.reducer;
